export enum BallDropEvents {
  START = "BallDropStart",
  RESET = "BallDropReset"
}
